import { ChangeDetectorRef, Component, NgZone, OnDestroy, OnInit, ViewChild, ElementRef, } from '@angular/core';
import * as L from 'leaflet';
import { latLng } from 'leaflet';
import { DataService } from '../../../services/data.service';
import 'leaflet-editable';
import 'leaflet-routing-machine';
import 'leaflet-geometryutil';
import 'leaflet.markercluster';
import 'leaflet.gridlayer.googlemutant';
import { catchError, concatMap, finalize, mergeMap, switchMap, tap, map, distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { combineLatest, EMPTY, Subject, Subscription, timer, of, Observable, concat, throwError, } from 'rxjs';
import { Route, Segment } from '../../../models/segment';
import { UserService } from '../../../services/user.service';
import { Accessibility, MapType, Registry, RoutingContainer, ExtendRoutingContainer, ExtendRoutingObj, SelectedSegment } from './registry';
import { TicketImagesModalComponent } from '../../modals/ticket-images/ticket-images-modal.component';
import { NewLayerComponent } from '../../modals/new-layer/new-layer.component';
import { NgbDropdown, NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { AppConfig } from 'src/app/app.config';
import { StreetViewService } from '../../../services/street-view.service';
import { ConfirmSentComponent } from '../../modals/confirm-sent/confirm-sent.component';
import { InfoModalComponent } from '../../modals/info-modal/info-modal.component';
import _ from 'lodash';
import { GeocodingService } from 'src/app/services/geocoding.service';
import { ErrorModalComponent } from '../../modals/error-modal/error-modal.component';

type SegmentPoint = { route: Route, marker: L.Marker, segmentIdx: number, pointIdx: number, pl: L.Polyline, latlng: L.LatLng };

@Component({
  selector: 'app-manage-map',
  templateUrl: './manage-map.component.html',
  styleUrls: ['./manage-map.component.scss']
})
export class ManageMapComponent implements OnInit, OnDestroy {
  optShown = false;
  infoShown = false;
  popupShown = false;
  markerPopup: any;

  creating = false;
  created = false;

  leafletOptions: any;
  // layers: Route[] = [];
  markerCluster;
  schoolMarkerCluster;

  projectId = 72;

  routings: RoutingContainer[] = [];

  currentLatlngs: SegmentPoint[] = [];
  hoveredPolyline: L.Polyline = null;
  hoveredPolylineOld: L.Polyline = null;
  hoverMarker: L.Marker = null;

  hoverMarkerBelongsTo: L.Polyline = null;

  isProceed = false;
  isLoadingText = 'Loading';

  address$: Observable<any[]>;
  addressLoading = false;
  addressInput$ = new Subject<string>();
  timer: Subscription;
  markerIcons = {
    OCCASIONALLY_UNSAFE: new L.Icon({
      iconUrl: 'https://cdn.rawgit.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-orange.png',
      shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
      iconSize: [25, 41],
      iconAnchor: [12, 41],
      popupAnchor: [1, -34],
      shadowSize: [41, 41]
    }),
    UNSAFE: new L.Icon({
      iconUrl: 'https://cdn.rawgit.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-red.png',
      shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
      iconSize: [25, 41],
      iconAnchor: [12, 41],
      popupAnchor: [1, -34],
      shadowSize: [41, 41]
    }),
    SAFE: new L.Icon({
      iconUrl: 'https://cdn.rawgit.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-green.png',
      shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
      iconSize: [25, 41],
      iconAnchor: [12, 41],
      popupAnchor: [1, -34],
      shadowSize: [41, 41]
    })
  };

  private map: L.DrawMap;

  private _mode: string;

  color: Accessibility = 'SAFE';
  colors = {
    SAFE: '#00b000',
    OCCASIONALLY_UNSAFE: '#ff7f00',
    UNSAFE: '#ff0000',
  };

  routeSaver: Subject<Route> = new Subject();
  routeSaverSub: Subscription;

  private _screen: MapType;

  legend: any[] = [];
  flattenLegend: any[] = [];

  dict: any;
  mapLoading: Subscription;
  fetchingLayerFailed = false;

  layerGroups: { [k in MapType]: { [l in Accessibility]: L.LayerGroup } };

  registry: Registry = new Registry();

  draw: L.Draw.Polyline = null;

  editableState = null;

  private _selectedRoute: Route = null;

  public chosenRoutes: Route[];

  accessibilities: { value: Accessibility, label: string }[] = [
    { value: 'SAFE', label: 'Safe' },
    { value: 'OCCASIONALLY_UNSAFE', label: 'Occasionally Unsafe' },
    { value: 'UNSAFE', label: 'Unsafe' },
  ];

  tiles: any[] = [];
  currentTileIdx = 1;

  colorMarkers: { [k in Accessibility]: L.Marker };

  isLayerPanelOpen = false;
  @ViewChild('layerDropdown', { static: false, read: NgbDropdown })
  private dropdown: NgbDropdown;

  selectedLayer: any = {};
  layerMode;

  drawControl;
  editableLayers: L.FeatureGroup;

  isToolbarInserted = false;

  shapeFile = null;

  hiddenSegments = [];
  hiddenSwitch = true;

  confirmPopup: L.Popup;

  changes: SelectedSegment[] = [];

  isClickedPolyline = false;

  clickedRoute: SelectedSegment = {
    polyline: null,
    route: null,
    segmentId: null,
    orgColor: null,
    chosenColor: null,
    extendRoutings: null
  };

  @ViewChild('layerFileInput', { static: true }) fileInput: ElementRef;

  constructor(
    private cd: ChangeDetectorRef,
    private zone: NgZone,
    private dataService: DataService,
    private userService: UserService,
    private modalService: NgbModal,
    private config: AppConfig,
    private gsv: StreetViewService, // DO NOT REMOVE!,
    private geocodingService: GeocodingService,
  ) { }

  get screen(): MapType {
    return this._screen;
  }

  set screen(value: MapType) {
    if (this._screen != value) {
      this.mode = null;
      this.selectedRoute = null;
    }

    this._screen = value;
    this.updateByLegend();
  }

  get mode(): string {
    return this._mode;
  }

  set mode(value: string) {
    console.log('mode change', this._mode, value);

    if (this._mode === 'visible' && value !== 'visible') {
      this.selectedRoute = null;
    }
    if (this._mode === 'routing' && value !== 'routing') {
      this.stopRouting();
    }
    if (this._mode === 'draw' && value !== 'draw') {
      this.stopDraw();
    }
    if (this._mode === 'edit' && value !== 'edit') {
      this.stopEditMode();
    }
    if (this._mode === 'extend' && value !== 'extend') {
      this.stopExtendMode();
    }

    this._mode = value;
  }

  ngOnInit() {
    this.projectId = this.userService.project.projectID.id;

    this.routeSaverSub = this.routeSaver.pipe(
      concatMap(route => {
        return this.dataService.saveRoute(this.projectId, route);
      })
    ).subscribe();

    this.initMap();
    this.initTypeahead();
    timer(1000, 10000).pipe(map(x => console.log('1s'), takeUntil(timer(10000)))).subscribe();
    this.checkProjectGeneralized();

    this.confirmPopup = L.popup({
      closeOnClick: false,
      autoClose: false,
      closeButton: false
    });

    var container = L.DomUtil.create('p');
    container.innerHTML = 'Warning<br />Are you sure to save changes?<br />';
    const confirmBtn = this.createButton('Save', container, 'popup-btn btn btn-success ml-2 mr-2 mt-2');
    const cancelBtn = this.createButton('Cancel', container, 'popup-btn btn btn-danger ml-2 mr-2 mt-2');

    this.confirmPopup.setContent(container);

    L.DomEvent.on(confirmBtn, 'click', () => {
      console.log('confirm');

      // Save Changes
      this.changes.forEach(e => {

        if (e.extendRoutings && (e.extendRoutings.main.routeContainer || e.extendRoutings.start.routeContainer || e.extendRoutings.end.routeContainer)) {

          if (e.extendRoutings.main.routeContainer) {
            let originPolyline = e.extendRoutings.main.routeContainer.clickedRoute.segments[e.extendRoutings.main.routeContainer.segmentId].polyline;

            const updateRouting = e.extendRoutings.main.routeContainer.route.segments[0].polyline.latLngs;
            originPolyline.setLatLngs(updateRouting);
            originPolyline.setStyle({ opacity: 1 });
          }

          if (e.extendRoutings.start.routeContainer || e.extendRoutings.end.routeContainer) {

            let orgPl = e.extendRoutings.start.routeContainer ? e.extendRoutings.start.routeContainer.clickedRoute.segments[e.extendRoutings.start.routeContainer.segmentId].polyline : e.extendRoutings.end.routeContainer.clickedRoute.segments[e.extendRoutings.end.routeContainer.segmentId].polyline;
            let adjustLatlngs;

            let start, end;

            Object.keys(e.extendRoutings).forEach(key => {

              if (key === 'start') {
                start = e.extendRoutings[key].oldLatlng && e.extendRoutings[key].oldLatlng.marker['inside'] ? this.clickedLine(orgPl, e.extendRoutings[key].oldLatlng.marker._latlng) : 0;
              }
              else if (key === 'end') {
                end = e.extendRoutings[key].oldLatlng && e.extendRoutings[key].oldLatlng.marker['inside'] ? this.clickedLine(orgPl, e.extendRoutings[key].oldLatlng.marker._latlng) : orgPl.getLatLngs().length;
              }
            });

            let orgLatlngs = orgPl.getLatLngs().slice(start, end + 1);

            let startExtend = [];
            let endExtend = [];
            if (e.extendRoutings.start.routeContainer && e.extendRoutings.start.oldLatlng && !e.extendRoutings.start.oldLatlng.marker['inside']) {
              if (e.extendRoutings.start.routeContainer.route.segments.length) {
                startExtend = e.extendRoutings.start.routeContainer.route.segments[0].polyline.latLngs;
              }
            }

            if (e.extendRoutings.end.routeContainer && e.extendRoutings.end.oldLatlng && !e.extendRoutings.end.oldLatlng.marker['inside']) {
              if (e.extendRoutings.end.routeContainer.route.segments.length) {
                endExtend = e.extendRoutings.end.routeContainer.route.segments[0].polyline.latLngs;
              }
            }

            adjustLatlngs = startExtend.slice(0, startExtend.length).concat(orgLatlngs).concat(endExtend.reverse().slice(1, endExtend.length + 1));

            orgPl.setLatLngs(adjustLatlngs);
            orgPl.setStyle({ opacity: 1 });
          }
          const clickedRoute = e.extendRoutings.main.routeContainer ? e.extendRoutings.main.routeContainer.clickedRoute : e.extendRoutings.start.routeContainer ? e.extendRoutings.start.routeContainer.clickedRoute : e.extendRoutings.end.routeContainer.clickedRoute;
          this.routeSaver.next(clickedRoute);

          Object.keys(e.extendRoutings).forEach(eR => {
            if (e.extendRoutings[eR].routeContainer && e.extendRoutings[eR].routeContainer.routing) {
              e.extendRoutings[eR].routeContainer.routing.remove();
            }
            e.extendRoutings[eR].routeContainer = null;
          });
        }
        else if (e.chosenColor && e.chosenColor !== e.orgColor) {
          this.routeSaver.next(e.route);
        }
      });

      this.currentLatlngs.forEach(e => {
        this.map.removeLayer(e.marker);
      });

      this.currentLatlngs = [];

      this.changes = [];
      this.clickedRoute = {
        chosenColor: null,
        orgColor: null,
        segmentId: null,
        route: null,
        polyline: null,
        extendRoutings: null
      };
      this.confirmPopup.remove();
    });

    L.DomEvent.on(cancelBtn, 'click', () => {
      console.log('cancel');

      this.changes.forEach(e => {

        if (e.chosenColor) {
          e.polyline.setStyle({ color: this.colors[e.orgColor] });
          e.route.segments[e.segmentId].accessibility = e.orgColor;
        }

        if (e.extendRoutings) {
          Object.keys(e.extendRoutings).forEach(eR => {
            if (e.extendRoutings[eR].routeContainer) {
              e.extendRoutings[eR].routeContainer.clickedRoute.segments[e.extendRoutings[eR].routeContainer.segmentId].polyline.setStyle({
                opacity: 1
              });
              if (e.extendRoutings[eR].routeContainer && e.extendRoutings[eR].routeContainer.routing) {
                e.extendRoutings[eR].routeContainer.routing.remove();
              }
              e.extendRoutings[eR].routeContainer = null;

              if (e.extendRoutings[eR].latlng) {
                this.map.removeLayer(e.extendRoutings[eR].latlng.marker);
              }
            }
          });
        }
      });

      this.currentLatlngs.forEach(e => {
        this.map.removeLayer(e.marker);
      });

      this.currentLatlngs = [];
      this.changes = [];
      this.clickedRoute = {
        chosenColor: null,
        orgColor: null,
        segmentId: null,
        route: null,
        polyline: null,
        extendRoutings: null
      };

      this.confirmPopup.remove();
    });
  }

  checkProjectGeneralized() {
    this.screen = 'crowd';
    combineLatest([
      this.dataService.genRouteCreating(this.projectId),
      this.dataService.genRouteCreated(this.projectId),
    ]).pipe(
      switchMap(([creating, created]) => {
        this.creating = creating;
        this.created = created;

        return of(created);
      }),
      tap(created => {
        if (created) {
          this.screen = 'generalized';
          this.editableState = 'generalized'
          let s = this.getRoutesInProject().pipe(
            finalize(() => s.unsubscribe())
          ).subscribe();
        } else {
          this.editableState = 'crowd';
          this.screen = 'crowd';
        }
      })
    ).subscribe();
  }

  isProjectMnger() {
    return this.userService.project.role === 'MAIN_PROJECT_MANAGER';
  }

  initTypeahead() {
    const project_location = localStorage.getItem('project_location');
    this.address$ = concat(
      of([]),
      this.addressInput$.pipe(
        distinctUntilChanged(),
        tap(() => this.addressLoading = true),
        switchMap(term => {
          if (term) {
            console.log(this.map.getCenter());
            let latlng;
            if (!project_location) { latlng = this.map.getCenter(); }
            else {
              const locations = project_location.split(',');
              var latitude = parseFloat(locations[1]),
                longitude = parseFloat(locations[0]);
              latlng = L.latLng(latitude, longitude);
            }
            return this.geocodingService.addressAutocomplete(term, latlng.lat, latlng.lng).pipe(
              catchError(() => of([])),
              map(result => {
                if (result.features) return result.features.map(r => Object.assign(r.properties, r.geometry));
                else return [];
              }),
              tap(() => this.addressLoading = false)
            );
          }
          this.addressLoading = false;
          // return of([]).pipe(
          //   map(() => this.addressLoading = false)
          // );
        })
      )
    )
  }

  findPos(latlng) {
    this.map.panTo({ lng: latlng.lon ? latlng.lon : latlng.lng, lat: latlng.lat });
    this.map.setZoom(18);
  }

  onInputAddress(event) {
    console.log('input', event);
    if (event.coordinates) {
      const latlng = L.latLng(event.coordinates[1], event.coordinates[0]);
      this.findPos(latlng);
    }
    else if (event.name) {
      this.geocodingService.findPosition(event.name).subscribe(response => {
        if (response && response.lat) this.findPos(response);
      }, err => {
        const errDlg = this.modalService.open(ErrorModalComponent);
        errDlg.componentInstance.header = 'Unknown address';
        errDlg.componentInstance.message = 'The location of this address could not be determined. Please enter a new address.';
      });
    }
  }

  createButton(label: string, container: any, className: string) {
    var btn = L.DomUtil.create('button', className, container);
    btn.setAttribute('type', 'button');
    btn.style.font = '12px/1.5 "Helvetica Neue", Arial, Helvetica, sans-serif';
    btn.innerHTML = label;
    return btn;
  }

  initMap() {
    let tileLayerOptions = {
      // attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
      maxZoom: 18,
      id: 'mapbox.streets',
      accessToken: 'pk.eyJ1IjoiYW50b242Mzc4IiwiYSI6IlBtMG5pMjgifQ.bGiCZKEStTnO5YjSzmkJZg'
    };

    this.tiles = [
      // tileLayer('https://api.tiles.mapbox.com/v4/{id}/{z}/{x}/{y}.png?access_token={accessToken}', tileLayerOptions),
      // @ts-ignore
      L.gridLayer.googleMutant({ type: 'satellite' }),
      this.config.getTileLayer()
    ];

    let pos;
    try {
      const center = _.cloneDeep(this.userService.project.project.projectData.center);
      pos = center ? latLng(center.coordinates.reverse()) : latLng(50.848656786354994, 4.349341392517091);
    } catch {
      pos = latLng(50.848656786354994, 4.349341392517091);
    }

    this.leafletOptions = {
      layers: [
        this.tiles[1]
      ],
      zoom: 14,
      editable: true,
      center: pos
    };

    this.map = L.map('map', this.leafletOptions);

    this.map.on(L.Draw.Event.CREATED, this.mapDrawCreatedHandler());
    this.map.on(L.Draw.Event.EDITED, this.mapDrawEditedHandler());
    this.map.on(L.Draw.Event.DELETED, this.mapDrawDeletedHandler());

    this.map.on('click', this.mapClickHandler());
    this.map.on('contextmenu', this.mapRightClickHandler());
    this.map.on('mousemove', this.mapMousemoveHandler());

    this.editableLayers = new L.FeatureGroup();
    this.editableLayers.addTo(this.map);

    console.log(this.map.zoomControl.getPosition());

    this.drawControl = new L.Control.Draw({
      position: "topright",
      draw: {
        polyline: {
          shapeOptions: {
            color: 'green',
            weight: 10
          }
        },
        polygon: {
          allowIntersection: false, // Restricts shapes to simple polygons
          drawError: {
            color: '#e1e100', // Color the shape will turn when intersects
            message: '<strong>Oh snap!<strong> you can\'t draw that!' // Message that will show when intersect
          },
          shapeOptions: {
            color: '#bada55'
          }
        },
        circle: false, // Turns off this drawing tool
        circlemarker: false,
        rectangle: false,
        marker: {
          // icon: new MyCustomMarker()
        }
      },
      edit: {
        featureGroup: this.editableLayers, //REQUIRED!!
      }
    });

    // @ts-ignore
    this.markerCluster = L.markerClusterGroup({
      spiderfyOnMaxZoom: true,
      showCoverageOnHover: false,
      iconCreateFunction: this.clusterIcon,
      // disableClusteringAtZoom: 18
    });

    // @ts-ignore
    this.schoolMarkerCluster = L.markerClusterGroup({
      spiderfyOnMaxZoom: true,
      showCoverageOnHover: false,
      iconCreateFunction: this.schoolClusterIcon,
    });


    this.map.addLayer(this.markerCluster);
    this.map.addLayer(this.schoolMarkerCluster);

    this.layerGroups = {
      'generalized': {
        'SAFE': L.layerGroup(),
        'UNSAFE': L.layerGroup(),
        'OCCASIONALLY_UNSAFE': L.layerGroup(),
      },
      'crowd': {
        'SAFE': L.layerGroup(),
        'UNSAFE': L.layerGroup(),
        'OCCASIONALLY_UNSAFE': L.layerGroup(),
      }
    };

    this.userService.getUserInfo().subscribe(user => this.addHomeMarker());
    this.colorMarkers = {
      'SAFE': L.marker([0, 0], {
        icon: L.icon({
          iconUrl: 'https://cdn.rawgit.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-green.png',
          iconSize: [25, 41],
          iconAnchor: [12, 43]
        })
      }),
      'UNSAFE': L.marker([0, 0], {
        icon: L.icon({
          iconUrl: 'https://cdn.rawgit.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-red.png',
          iconSize: [25, 41],
          iconAnchor: [12, 43]
        })
      }),
      'OCCASIONALLY_UNSAFE': L.marker([0, 0], {
        icon: L.icon({
          iconUrl: 'https://cdn.rawgit.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-orange.png',
          iconSize: [25, 41],
          iconAnchor: [12, 43]
        })
      })
    };

    this.getLegend();
  }

  correctLatlngs(): void {
    const pl = this.currentLatlngs[0].pl;
    const latlngs = pl.getLatLngs() as L.LatLng[];

    for (let i = 0; i < latlngs.length; i++) {
      const element = latlngs[i];
      this.currentLatlngs.forEach(e => {
        if (element.equals(e.latlng)) {
          e.pointIdx = i;
        }
      });
    }
  }

  nearestLatlng(pl: L.Polyline, latlng: L.LatLng): { idx: number, latLng: L.LatLng } {
    let nearLatlng = L.GeometryUtil.closest(this.map, pl, latlng);

    let i = 0,
      start = {},
      end = {};

    let plLatlngs = pl.getLatLngs() as L.LatLng[];

    while (plLatlngs[i + 1]) {
      //belongsSegment returns a Boolean
      const segmentFound = L.GeometryUtil.belongsSegment(nearLatlng, plLatlngs[i], plLatlngs[i + 1]);
      if (segmentFound) {
        start = plLatlngs[i]
        end = plLatlngs[i + 1]
        break;
      }
      i++;
    }

    return {
      idx: i + 1,
      latLng: nearLatlng
    };
  }


  clearLayerGroup(mapType: MapType = null, accessibility: Accessibility = null) {
    if (mapType && accessibility) {
      this.registry.removePolylines(mapType, accessibility);
      return;
    }

    if (mapType) {
      this.clearLayerGroup(mapType, 'SAFE');
      this.clearLayerGroup(mapType, 'OCCASIONALLY_UNSAFE');
      this.clearLayerGroup(mapType, 'UNSAFE');
      return;
    }

    this.clearLayerGroup('generalized');
    this.clearLayerGroup('crowd');
  }


  getRoutesInProject() {
    return this.dataService.genRouteInProject(this.projectId).pipe(
      tap(result => {
        this.clearLayerGroup('generalized');

        result.forEach(route => {

          const rt = new Route;
          rt.id = route.entityID.id2;
          rt.projectId = route.projectID.id;

          const routeAttr = route.genericAttributes.attributes;
          const mode = routeAttr.mode && routeAttr.mode.length > 0 ? routeAttr.mode[0] : '';
          const created = route.timeStamp;

          route.segments.forEach(s => {
            try {
              const attrs = s.genericAttributes.attributes;
              const coords = attrs.geometry[0].coordinates.map(c => [c[1], c[0]]);
              const accessibility = attrs.accessibility[0];
              const hidden = attrs.invisible_in_project
                && attrs.invisible_in_project.length > 0
                && attrs.invisible_in_project.indexOf(this.projectId) >= 0;

              this.polyline(
                coords,
                accessibility,
                rt,
                'generalized',
                null,
                s.entityID.id2,
                !hidden,
                '',
                created,
                mode);
            } catch (e) {
              console.log(e);
            }
          });
        });
      })
    );
  }

  ngOnDestroy() {

    if (this.timer) this.timer.unsubscribe();
    this.routeSaverSub && this.routeSaverSub.unsubscribe();
  }

  toggleOptions() {
    this.optShown = !this.optShown;
  }

  toggleMapType() {
    try {
      this.tiles[this.currentTileIdx].removeFrom(this.map);
    } catch { }
    // this.currentTileIdx = this.currentTileIdx == 2 ? 0 : this.currentTileIdx + 1;
    this.currentTileIdx = this.currentTileIdx == 1 ? 0 : this.currentTileIdx + 1;
    this.tiles[this.currentTileIdx].addTo(this.map);
  }

  startDraw() {

    console.log('start draw');

    if (this.mode == 'draw') {
      this.mode = null;
      return;
    }

    this.mode = 'draw';

    if (!this.draw) {
      this.draw = new L.Draw.Polyline(this.map, { shapeOptions: { color: 'green' } });
    }
    this.draw.enable();
  }

  stopDraw() {
    console.log('stop draw');
    if (this.draw) {
      console.log('disable draw');
      this.draw.disable();
    }
  }

  startDelete() {
    if (this.mode == 'delete') {
      if (this.currentLatlngs.length >= 2) {
        this.correctLatlngs();
        this.removeSegment(this.color);
        timer(300).subscribe(() => {
          this.currentLatlngs.forEach(latlng => {
            this.map.removeLayer(latlng.marker)
          })
          this.currentLatlngs = [];
        })
      } else if (this.currentLatlngs.length == 1) {
        this.map.removeLayer(this.currentLatlngs[0].marker);
        this.currentLatlngs = []
      }
    }
    this.mode = this.mode == 'delete' ? null : 'delete';
  }

  startRouting() {
    this.mode = this.mode == 'routing' ? null : 'routing';

    if (this.mode == 'routing') {
      L.DomUtil.addClass(this.map['_container'], 'crosshair-cursor-enabled');
      this.map.on('click', this.handleRoutingClick, this);
    }
  }

  stopRouting() {
    L.DomUtil.removeClass(this.map['_container'], 'crosshair-cursor-enabled');
    this.map.off('click', this.handleRoutingClick, this);

    console.log(this.routings);

    this.routings.forEach(r => {
      let coords = null;
      try {
        coords = r.route.segments[0].coords;
        r.route.segments = [];
        this.polyline(coords, this.color, r.route, this.screen);
      } catch (e) { }

      if (r && r.routing) {
        r.routing.remove();
      }
    });

    this.routings = [];

  }

  handleRoutingClick(e: L.LeafletMouseEvent) {

    if (e && e.latlng) {
      let routingContainer: RoutingContainer = this.routings.pop();

      if (!routingContainer) {
        routingContainer = { routing: null, route: null };
        routingContainer.routing = this.newRouting(routingContainer);
      }

      let waypoints = routingContainer.routing.getWaypoints();

      if (waypoints[0].latLng == null) {
        waypoints[0] = L.Routing.waypoint(L.latLng(e.latlng.lat, e.latlng.lng));
        routingContainer.routing.setWaypoints(waypoints);
        this.routings.push(routingContainer);
      } else {
        waypoints[1] = L.Routing.waypoint(L.latLng(e.latlng.lat, e.latlng.lng));
        routingContainer.routing.setWaypoints(waypoints);
        this.routings.push(routingContainer);
        this.routings.push(null);
      }
    }
  }

  handleExtendClick(e: L.LeafletMouseEvent) {

    if (e && e.latlng) {
      // get extend routing
      const extendRoute = this.clickedRoute.extendRoutings;
      let latlng = L.GeometryUtil.closest(this.map, this.clickedRoute.polyline, e.latlng);
      let dist = L.GeometryUtil.distance(this.map, latlng, e.latlng);

      if (dist > 20) {

        const route = this.clickedRoute.route;
        const pl = this.clickedRoute.polyline;

        pl.setStyle({ opacity: 0.5 });

        let routingContainer = { routing: null, route: null, clickedRoute: route, segmentId: route.contains(pl), dragIdx: 0 };

        // Check if clicked point is in clicked route

        const key = 'main';

        if (extendRoute[key].routeContainer && extendRoute[key].routeContainer.routing) {
          extendRoute[key].routeContainer.routing.remove();
        }
        extendRoute[key].routeContainer = null;

        // const transLatlngs: any = pl.getLatLngs().slice(start, end + 1);
        // let plline = L.polyline(transLatlngs, { color: this.colors[route.segments[route.contains(pl)].accessibility], weight: 5, opacity: 1 });

        // extendRoute[reverseKey].routeContainer.routing = plline;
        // this.map.addLayer(plline);

        let plan = new L.Routing.Plan([], {
          createMarker: this.extendMarker.bind(this)
        });

        let routing: L.Routing.Control = new L.Routing.Control({
          autoRoute: false,
          show: false,
          plan: plan,
          routeLine: this.routeLine,
          lineOptions: {
            styles: [{ color: this.colors[route.segments[route.contains(pl)].accessibility], opacity: 1, weight: 5 }],
            addWaypoints: false
          },
          router: new L.Routing.OSRMv1({
            serviceUrl: this.config.getOsrmServiceUrl() + 'foot/route/v1',
            routingOptions: {
              profile: 'foot'
            }
          })
        });

        plan.on('waypointschanged', e => {
          console.log('route');
          routing.route();
        });

        routing.addTo(this.map);

        routingContainer.route = new Route();
        routingContainer.route.mapType = this.screen;
        routingContainer.route.projectId = this.projectId;

        routing.on('routesfound', e => {
          routingContainer.route.init(e.routes[0].coordinates, this.clickedRoute.orgColor);
          console.log('extend-mode-main-routesfound');
        });

        routingContainer.routing = routing;
        extendRoute[key].routeContainer = routingContainer;

        let waypoints = routingContainer.routing.getWaypoints();

        const latLngs: any = this.clickedRoute.polyline.getLatLngs();
        waypoints[0] = L.Routing.waypoint(latLngs[0]);
        waypoints[1] = L.Routing.waypoint(e.latlng);
        waypoints[2] = L.Routing.waypoint(latLngs[latLngs.length - 1]);
        routingContainer.routing.setWaypoints(waypoints);
      }
    }
  }

  newRouting(container: RoutingContainer): L.Routing.Control {

    let plan = new L.Routing.Plan([], {
      createMarker: this.routeMarker.bind(this)
    });

    let routing: L.Routing.Control = new L.Routing.Control({
      autoRoute: false,
      show: false,
      plan: plan,
      routeLine: this.routeLine,
      lineOptions: {
        styles: [{ color: this.colors[this.color], opacity: 1, weight: 5 }]
      },
      router: new L.Routing.OSRMv1({
        serviceUrl: this.config.getOsrmServiceUrl() + 'foot/route/v1',
        routingOptions: {
          profile: 'foot'
        }
      })
    });

    plan.on('waypointschanged', e => {
      routing.route();
    });

    routing.addTo(this.map);

    container.route = new Route();
    container.route.mapType = this.screen;
    container.route.projectId = this.projectId;

    routing.on('routesfound', e => {
      container.route.init(e.routes[0].coordinates, this.color);

      console.log('routesfound', this.routings);

      this.routeSaver.next(container.route);
    });

    return routing;
  }

  routeMarker(i, waypoint, n) {
    if (i == 0)
      return L.marker(waypoint.latLng, {
        icon: this.markerIcons[this.color],
        draggable: true
      }).bindTooltip(`${this.userService.user.attributes.address[0].street} ${this.userService.user.attributes.address[0].houseNumber}`);

    if (i == n - 1)
      return L.marker(waypoint.latLng, {
        icon: this.markerIcons[this.color],
        draggable: true
      });

    return L.marker(waypoint.latLng, { icon: L.icon({ iconUrl: 'assets/marker/dot.png', iconSize: [19, 19] }), draggable: true });
  }

  routeLine(route, options) {
    let line = L.Routing.line(route, options);
    let tooltip = L.tooltip({ sticky: true, direction: 'top' }).setContent('Drag to route');
    line.eachLayer(l => { l.bindTooltip(tooltip) });
    return line;
  }

  extendMarker(i, waypoint, n) {
    if (i == 0 || i == n - 1)
      return null;

    return L.marker(waypoint.latLng, { icon: L.icon({ iconUrl: 'assets/marker/dot.png', iconSize: [19, 19] }), draggable: true });
  }

  generateMap() {
    this.dataService.genRouteCreate(this.projectId).subscribe(() => {
      this.showGeneralisationInfo('Good news!', 'The generalisation has started. You will receive an email when it is finished.', 'Ok');
      this.getRoutesAfterCreating();
    }, err => {
      this.showGeneralisationInfo('Bad news!', 'The generalisation could not be started. Please try again later. If the problem persists please contact Abeona.', 'Close');
    });
  }

  showGeneralisationInfo(header, text, label) {
    const infoDlg = this.modalService.open(InfoModalComponent);
    infoDlg.componentInstance.data = {
      text,
      header,
      label
    };
  }

  getRoutesAfterCreating() {
    let repeat = new Subject<void>();
    let countdown = 0;
    let period = 10000;
    repeat.pipe(
      mergeMap(() => this.dataService.genRouteCreating(this.projectId)),
      mergeMap(result => {
        this.creating = result;
        if (result) {
          if (countdown > 60000) {
            period = 60000;
          }
          this.timer = timer(period).subscribe(() => { repeat.next() });
          countdown += 10000;
          return EMPTY;
        } else {
          return this.dataService.genRouteCreated(this.projectId).pipe(
            tap(created => {
              this.created = created;
              if (created) {
                this.screen = 'generalized';
                this.editableState = 'generalized'
                this.getRoutesInProject().subscribe();
              }
            }));
        }
      })
    ).subscribe();

    repeat.next();
  }

  getKeyByValue(object, value) {
    return Object.keys(object).find(key => object[key] === value);
  }

  polyline(
    coords,
    accessibility: Accessibility,
    route: Route | null,
    mapType: MapType,
    idx: number = null,
    segmentId = null,
    visible: boolean = true,
    description: string = '',
    created: string = '',
    mode: string = '') {

    let key;
    if (!this.colors[accessibility]) {
      key = this.getKeyByValue(this.colors, accessibility);
    } else {
      key = accessibility;
    }

    let pl = L.polyline(coords, { color: this.colors[key], opacity: visible ? 1.0 : this.hiddenSwitch ? 0.3 : 0, weight: 5 });

    pl.on('click', this.polylineClickHandler(pl), this)
      .on('mouseover', this.polylineMouseoverHandler(pl))
      .on('mouseout', this.polylineMouseoutHandler(pl))
      .on('editable:vertex:new editable:vertex:deleted editable:vertex:dragend', this.polylineEditableHandler(pl))
      .on('editable:vertex:drag', this.polylineEditableDragHandler(pl))
      .addTo(this.layerGroups[mapType][key]);

    route = route || new Route();
    route.mapType = mapType;
    route.mode = mode || 'OTHER';
    route.created = created;
    route.projectId = route.projectId || this.projectId;

    const segment = new Segment(pl, key);
    segment.id = segmentId;
    segment.visible = visible;
    segment.description = description;

    this.hiddenSegments.push(segment);

    if (idx === null) {
      route.add(segment);
    } else {
      route.insert(segment, idx);
    }

    this.registry.add({
      route,
      polyline: pl,
      map: this.layerGroups[this.screen][key],
      accessibility: key,
      mapType: this.screen,
      segment,
    });

    return pl;
  }

  changesIsExist() {

    for (let index = 0; index < this.changes.length; index++) {

      if ((this.changes[index].extendRoutings && (this.changes[index].extendRoutings.main.routeContainer || this.changes[index].extendRoutings.start.routeContainer || this.changes[index].extendRoutings.end.routeContainer)) || (this.changes[index].chosenColor && this.changes[index].chosenColor !== this.changes[index].orgColor)) {
        return true;
      }
    }
    return false;
  }

  mapRightClickHandler() {
    return (e: L.LeafletMouseEvent) => {
      if (this.mode == 'extend' || this.mode == 'edit') {
        if (this.changesIsExist()) {
          this.confirmPopup.setLatLng(this.map.getBounds().getCenter()).openOn(this.map);
        }
      }
    }
  }

  mapMousemoveHandler() {
    return (e: L.LeafletMouseEvent) => {
      if (this.mode === 'color' && this.hoveredPolylineOld) {

        const closest = this.nearestLatlng(this.hoveredPolylineOld, e.latlng);

        if (!this.hoverMarker) {
          this.hoverMarker = this.colorMarkers[this.color];
          console.log('marker add');
          this.hoverMarker.addTo(this.map);
        }
        this.hoverMarker.setLatLng(closest.latLng);
      }
    }
  }

  polylineMouseoverHandler(pl) {
    return (e: L.LeafletMouseEvent) => {
      this.hoveredPolyline = pl;

      if (this.mode == 'color') {
        console.log('mouseover');
        this.resetOldHoveredPolyline();
        this.hoveredPolyline.setStyle({ weight: 7 });
        this.hoveredPolylineOld = this.hoveredPolyline;
      }
    }
  }

  polylineMouseoutHandler(pl) {
    return () => {

      if (this.mode == 'color') {
        console.log('mouseout');
        if (this.hoveredPolyline) {
          this.hoveredPolylineOld = this.hoveredPolyline;
          timer(100).subscribe(() => {
            this.resetOldHoveredPolyline();
          });
        }
      }

      this.hoveredPolyline = null
    }
  }

  resetOldHoveredPolyline() {

    console.log('reset', !!this.hoveredPolyline, !!this.hoveredPolylineOld, this.hoveredPolyline == this.hoveredPolylineOld);

    if (this.hoveredPolylineOld && (this.hoveredPolyline != this.hoveredPolylineOld)) {
      this.hoveredPolylineOld.setStyle({ weight: 5 });
      if (this.hoverMarker) {
        console.log('marker remove');
        this.hoverMarker.removeFrom(this.map);
        this.hoverMarker = null;
      }
      this.hoveredPolylineOld = null;
    }
  }

  isCrowdScreen() {
    return this.editableState === 'generalized' && this.screen === 'crowd';
  }

  hideAllChosenRoutes() {
    if (this.chosenRoutes && this.chosenRoutes.length) {
      for (const route of this.chosenRoutes) {
        for (const seg of route.segments) {
          const pl = seg.polyline as L.Polyline;
          pl.setStyle({
            opacity: 0
          });
        }
      }
    }
  }

  restoreVisibilityRoutes() {
    if (this.chosenRoutes && this.chosenRoutes.length) {
      for (const route of this.chosenRoutes) {
        for (const seg of route.segments) {
          const pl = seg.polyline as L.Polyline;
          pl.setStyle({
            opacity: seg.visible ? 1.0 : this.hiddenSwitch ? 0.3 : 0
          });
        }
      }
    }
  }

  polylineClickHandler(pl) {
    return (e) => {
      L.DomEvent.stopPropagation(e);
      console.log('polyclick', e, this.registry.getByPolyline(pl));

      this.registry.allPolylines().forEach(poly => poly.disableEdit());

      const regItem = this.registry.getByPolyline(pl);
      if (regItem) {
        const route = regItem.route;

        if (this.isCrowdScreen()) {
          this.selectedRoute = route;
        }

        if (this._mode === 'visible') {
          if (this.editableState === 'crowd' && this.screen === 'crowd') {
            if (this.chosenRoutes && this.chosenRoutes.length) {
              this.restoreVisibilityRoutes();
            }
            this.chosenRoutes = this.registry.getPolylinesByLatlng(this.map, e.latlng).map(item => item.route);
            console.log('polylines', e, this.chosenRoutes);
            this.hideAllChosenRoutes();
          } else {
            this.selectedRoute = route;
          }
        }

        if (this._mode === 'edit') {
          e.target.enableEdit();
          this.color = route.segments[route.contains(pl)].accessibility;
          this.clickedRoute = {
            polyline: pl,
            route,
            segmentId: route.contains(pl),
            orgColor: route.segments[route.contains(pl)].accessibility,
            chosenColor: null,
            extendRoutings: null
          };
        }

        if (this._mode === 'color') {
          // pl.addLatLng(e.latlng);

          const closest = this.nearestLatlng(pl, e.latlng);

          const plLatlngs = pl.getLatLngs() as L.LatLng[];
          plLatlngs.splice(closest.idx, 0, closest.latLng);

          pl.setLatLngs(plLatlngs);

          if (this.currentLatlngs.length >= 2) {
            this.currentLatlngs = [];
          } else if (this.currentLatlngs.length === 1) {
            if (route.id !== this.currentLatlngs[0].route.id) {
              this.map.removeLayer(this.currentLatlngs[0].marker);
              this.currentLatlngs = [];
            }
          }

          const marker = L.marker(closest.latLng, {
            icon: this.markerIcons[this.color]
          }).addTo(this.map);

          this.currentLatlngs.push({
            route,
            marker,
            latlng: closest.latLng,
            segmentIdx: route.contains(pl),
            pointIdx: closest.idx,
            pl,
          });

          if (this.currentLatlngs.length >= 2) {
            this.correctLatlngs();
            this.changeColor(this.color);
            timer(300).subscribe(() => {
              this.currentLatlngs.forEach(latlng => {
                this.map.removeLayer(latlng.marker);
              });
            });
          }
        }

        if (this._mode === 'delete') {
          // pl.addLatLng(e.latlng);

          const closest = this.nearestLatlng(pl, e.latlng);

          const plLatlngs = pl.getLatLngs() as L.LatLng[];
          plLatlngs.splice(closest.idx, 0, closest.latLng);

          pl.setLatLngs(plLatlngs);

          if (this.currentLatlngs.length >= 2) {
            this.currentLatlngs = [];
          } else if (this.currentLatlngs.length === 1) {
            if (route.id !== this.currentLatlngs[0].route.id) {
              this.map.removeLayer(this.currentLatlngs[0].marker);
              this.currentLatlngs = [];
            }
          }

          const marker = L.marker(closest.latLng, {
            icon: this.markerIcons[this.color]
          }).addTo(this.map);

          this.currentLatlngs.push({
            route,
            marker,
            latlng: closest.latLng,
            segmentIdx: route.contains(pl),
            pointIdx: closest.idx,
            pl,
          });
        }

        if (this._mode === 'extend') {
          console.log('extend mode');

          this.color = route.segments[route.contains(pl)].accessibility;
          this.clickedRoute = {
            polyline: pl,
            route,
            segmentId: route.contains(pl),
            orgColor: route.segments[route.contains(pl)].accessibility,
            chosenColor: null,
            extendRoutings: null
          };
          this.isClickedPolyline = true;
          let extendRoute = null;

          // Check if already changes are made for chosen polyline
          let ind = this.changes.findIndex(change => change.polyline === pl);
          if (ind !== -1) {
            this.clickedRoute = this.changes[ind];
            extendRoute = this.changes[ind].extendRoutings;
          } else {
            extendRoute = {
              start: {
                routeContainer: null,
                latlng: null,
                oldLatlng: null
              },
              main: {
                routeContainer: null,
                latlng: null,
                oldLatlng: null
              },
              end: {
                routeContainer: null,
                latlng: null,
                oldLatlng: null
              }
            };
            this.clickedRoute.extendRoutings = extendRoute;

            ind = this.changes.length;
            this.changes.push({
              polyline: pl,
              route,
              segmentId: route.contains(pl),
              orgColor: route.segments[route.contains(pl)].accessibility,
              chosenColor: null,
              extendRoutings: extendRoute
            });
          }

          this.changes.forEach((e, i) => {
            if (i !== ind) {
              if (e.extendRoutings) {
                Object.keys(e.extendRoutings).forEach(key => {
                  if (e.extendRoutings[key].latlng) {
                    this.map.removeLayer(e.extendRoutings[key].latlng.marker);
                  }
                });
              }
            }
          });

          if (this.currentLatlngs.length >= 2) {
            this.currentLatlngs.forEach(latlng => {
              this.map.removeLayer(latlng.marker);
            });
            this.currentLatlngs = [];
          }

          [
            {
              ind: 0,
              latlng: pl._latlngs[0]
            },
            {
              ind: pl._latlngs.length - 1,
              latlng: pl._latlngs[pl._latlngs.length - 1]
            }
          ].forEach(point => {
            const marker = L.marker(point.latlng, {
              pointIdx: point.ind.toString(),
              icon: this.markerIcons[this.color],
              draggable: true
            } as L.MarkerOptions).addTo(this.map);

            const key = point.ind === 0 ? 'start' : 'end';

            extendRoute[key].latlng = {
              route,
              marker,
              segmentIdx: route.contains(pl),
              pointIdx: point.ind,
              pl,
            };

            this.currentLatlngs.push({
              route,
              marker,
              segmentIdx: route.contains(pl),
              pointIdx: point.ind,
              pl,
              latlng: point.latlng
            });

            marker.on('dragend', (drageE) => {

              pl.setStyle({
                opacity: 0.3
              });

              extendRoute.start.oldLatlng = Object.assign(extendRoute.start.latlng);
              extendRoute.end.oldLatlng = Object.assign(extendRoute.end.latlng);

              const routingContainer = {
                routing: null,
                route: null,
                clickedRoute: route,
                segmentId: route.contains(pl),
                dragIdx: parseInt(drageE.target.options['pointIdx'], 10)
              };

              const latlng = L.GeometryUtil.closest(this.map, pl, drageE.target._latlng);
              const dist = L.GeometryUtil.distance(this.map, latlng, drageE.target._latlng);

              const key = parseInt(drageE.target.options['pointIdx'], 10) > 0 ? 'end' : 'start';
              const reverseKey = key === 'start' ? 'end' : 'start';

              if (extendRoute[key].routeContainer && extendRoute[key].routeContainer.routing) {
                extendRoute[key].routeContainer.routing.remove();
              }
              extendRoute[key].routeContainer = null;

              if (dist <= 20) {
                drageE.target.setLatLng(latlng);

                drageE.target['inside'] = true;

                if (extendRoute[reverseKey].latlng.marker['inside']
                  && extendRoute[reverseKey].routeContainer
                  && extendRoute[reverseKey].routeContainer.routing) {
                  extendRoute[reverseKey].routeContainer.routing.remove();
                  extendRoute[reverseKey].routeContainer.routing = null;
                }

                let start, end;
                Object.keys(extendRoute).forEach(key => {
                  if (key == 'start') {
                    start = extendRoute[key].latlng.marker['inside'] ? this.clickedLine(pl, extendRoute[key].latlng.marker._latlng) : 0;
                  }
                  else {
                    end = extendRoute[key].latlng.marker['inside'] ? this.clickedLine(pl, extendRoute[key].latlng.marker._latlng) : extendRoute[key].latlng.marker.options['pointIdx'];
                  }
                });

                const transLatlngs = pl.getLatLngs().slice(start, end + 1);
                let plline = L.polyline(transLatlngs, { color: this.colors[route.segments[route.contains(pl)].accessibility], weight: 5, opacity: 1 });

                routingContainer.route = new Route();
                routingContainer.route.mapType = this.screen;
                routingContainer.route.projectId = this.projectId;

                routingContainer.routing = plline;
                this.map.addLayer(plline);
                extendRoute[key].routeContainer = routingContainer;
              }
              else {
                drageE.target['inside'] = false;

                // Display the route for inside marker

                if (extendRoute[reverseKey].latlng.marker['inside']
                  && extendRoute[reverseKey].routeContainer
                  && !extendRoute[reverseKey].routeContainer.routing) {
                  let start, end;
                  Object.keys(extendRoute).forEach(key => {

                    if (key == 'start') {
                      start = extendRoute[key].latlng.marker['inside'] ? this.clickedLine(pl, extendRoute[key].latlng.marker._latlng) : 0;
                    }
                    else {
                      end = extendRoute[key].latlng.marker['inside'] ? this.clickedLine(pl, extendRoute[key].latlng.marker._latlng) : extendRoute[key].latlng.marker.options['pointIdx'];
                    }
                  });

                  const transLatlngs = pl.getLatLngs().slice(start, end + 1);
                  let plline = L.polyline(transLatlngs, { color: this.colors[route.segments[route.contains(pl)].accessibility], weight: 5, opacity: 1 });

                  extendRoute[reverseKey].routeContainer.routing = plline;
                  this.map.addLayer(plline);
                }

                let plan = new L.Routing.Plan([], {
                  createMarker: this.extendMarker.bind(this)
                });

                let routing: L.Routing.Control = new L.Routing.Control({
                  autoRoute: false,
                  show: false,
                  plan: plan,
                  routeLine: this.routeLine,
                  lineOptions: {
                    styles: [{ color: this.colors[route.segments[route.contains(pl)].accessibility], opacity: 1, weight: 5 }]
                  },
                  router: new L.Routing.OSRMv1({
                    serviceUrl: this.config.getOsrmServiceUrl() + 'foot/route/v1',
                    routingOptions: {
                      profile: 'foot'
                    }
                  })
                });

                plan.on('waypointschanged', e => {
                  console.log('route');
                  routing.route();
                });

                routing.addTo(this.map);

                routingContainer.route = new Route();
                routingContainer.route.mapType = this.screen;
                routingContainer.route.projectId = this.projectId;

                routing.on('routesfound', e => {
                  routingContainer.route.init(e.routes[0].coordinates, this.colors[route.segments[route.contains(pl)].accessibility]);
                  console.log('extend-mode-routesfound');
                });

                routingContainer.routing = routing;
                extendRoute[key].routeContainer = routingContainer;

                let waypoints = routingContainer.routing.getWaypoints();

                waypoints[0] = L.Routing.waypoint(L.latLng(drageE.target._latlng.lat, drageE.target._latlng.lng));
                waypoints[1] = L.Routing.waypoint(L.latLng(pl._latlngs[parseInt(drageE.target.options['pointIdx'])].lat, pl._latlngs[parseInt(drageE.target.options['pointIdx'])].lng));
                routingContainer.routing.setWaypoints(waypoints);
              }
            });
          });
        }
      }
    };
  }

  polylineEditableHandler(pl) {
    return (e: any) => {
      console.log('edit', e);
      let rt = this.registry.getByPolyline(e.target).route;
      this.routeSaver.next(rt);
    }
  }

  polylineEditableDragHandler(pl) {
    return (e: any) => {

      // here we make sure that segments of route are continuous when inner segment's first or
      // last vertex being dragged.

      let v = e.vertex;
      let vIdx = v.getIndex(); //vertex number in a segment

      let route = this.registry.getByPolyline(pl).route;
      let segmentIdx = route.contains(pl); // segment number in a route

      // console.log(segmentIdx, route.lastSegmentIdx(), vIdx, pl.getLatLngs().length - 1);

      // check if last vertex of inner segment being dragged and ajust first vertex of next segment

      if (segmentIdx < route.lastSegmentIdx() && vIdx == pl.getLatLngs().length - 1) {
        let adjacentPolyline = route.segments[segmentIdx + 1].polyline;
        let adjacentLatlngs = adjacentPolyline.getLatLngs();
        adjacentLatlngs[0] = e.latlng;
        adjacentPolyline.setLatLngs(adjacentLatlngs);
      }

      // check if first vertex of inner segment being dragged and ajust last vertex of previous segment

      if (segmentIdx > 0 && vIdx == 0) {
        let adjacentPolyline = route.segments[segmentIdx - 1].polyline;
        let adjacentLatlngs = adjacentPolyline.getLatLngs();
        adjacentLatlngs[adjacentLatlngs.length - 1] = e.latlng;
        adjacentPolyline.setLatLngs(adjacentLatlngs);
      }
    }
  }

  changeColor(accessibility: Accessibility) {
    let route = this.currentLatlngs[0].route;

    let from: SegmentPoint;
    let to: SegmentPoint;

    let [p0, p1] = this.currentLatlngs;

    if ((p0.segmentIdx == p1.segmentIdx && p0.pointIdx > p1.pointIdx) || p0.segmentIdx > p1.segmentIdx) {
      [to, from] = this.currentLatlngs;
    } else {
      [from, to] = this.currentLatlngs;
    }

    let segmentIdx = from.segmentIdx;
    let pointIdx = from.pointIdx;

    // if segment's last point, ignore it and move to next segment
    if (pointIdx >= route.segments[segmentIdx].coordsLastIdx) {
      segmentIdx++;
      pointIdx = 0;
    }

    // creating pre-segment if segment is splitted
    if (pointIdx > 0) {
      let preLatLngs = route.segments[segmentIdx].coords.slice(0, pointIdx + 1);
      this.polyline(
        preLatLngs,
        route.segments[segmentIdx].accessibility,
        route,
        route.mapType,
        segmentIdx++, null,
        true, '',
        route.created,
        route.mode);
      to.segmentIdx++;
    }

    let baseSegmentIdx = segmentIdx; // remember index of base segment. base segment will be modified later

    let newLatLngs = [];

    while (segmentIdx < to.segmentIdx || (pointIdx < to.pointIdx)) {
      newLatLngs.push(route.segments[segmentIdx].coords[pointIdx]);
      pointIdx++;
      if (pointIdx > route.segments[segmentIdx].coordsLastIdx) {
        pointIdx = 1; // we will ignore first (zero) element, its the same as previous

        if (segmentIdx > baseSegmentIdx) { // remove parsed segment if its not base segment
          this.registry.removePolyline(route.segments[segmentIdx].polyline);
          route.remove(segmentIdx);
          to.segmentIdx--;
        } else {
          segmentIdx++;
        }
      }
    }

    if (pointIdx == to.pointIdx) { // end point was not zero point of some segment
      newLatLngs.push(route.segments[segmentIdx].coords[pointIdx]);

      if (pointIdx < route.segments[segmentIdx].coordsLastIdx) { // we have to create last portion of segment

        let postLatLngs = route.segments[segmentIdx].coords.slice(pointIdx);

        if (segmentIdx == baseSegmentIdx) {
          // we still on base segment and have to create NEW segment for last portion
          this.polyline(
            postLatLngs,
            route.segments[segmentIdx].accessibility,
            route,
            route.mapType,
            segmentIdx + 1, null,
            true, '',
            route.created,
            route.mode);
        } else {
          // we are on one of the next segments, so we can just modify current for last portion
          this.changeSegment(route.segments[segmentIdx], postLatLngs, route.segments[segmentIdx].accessibility, route.mapType);
        }
      } else if (segmentIdx > baseSegmentIdx) {
        // we have to remove last segment if its not base
        this.registry.removePolyline(route.segments[segmentIdx].polyline);
        route.remove(segmentIdx);
      }
    }

    // now we modify base segment for new color and save it

    this.changeSegment(route.segments[baseSegmentIdx], newLatLngs, accessibility, route.mapType);
    this.optimizeRoute(route);
    this.routeSaver.next(route);
  }

  removeSegment(accessibility: Accessibility) {
    let route = this.currentLatlngs[0].route;

    let from: SegmentPoint;
    let to: SegmentPoint;

    let [p0, p1] = this.currentLatlngs;

    if ((p0.segmentIdx == p1.segmentIdx && p0.pointIdx > p1.pointIdx) || p0.segmentIdx > p1.segmentIdx) {
      [to, from] = this.currentLatlngs;
    } else {
      [from, to] = this.currentLatlngs;
    }

    let segmentIdx = from.segmentIdx;
    let pointIdx = from.pointIdx;

    // if segment's last point, ignore it and move to next segment
    if (pointIdx >= route.segments[segmentIdx].coordsLastIdx) {
      segmentIdx++;
      pointIdx = 0;
    }

    // creating pre-segment if segment is splitted
    if (pointIdx > 0) {
      let preLatLngs = route.segments[segmentIdx].coords.slice(0, pointIdx + 1);
      this.polyline(
        preLatLngs,
        route.segments[segmentIdx].accessibility,
        route,
        route.mapType,
        segmentIdx++, null,
        true, '',
        route.created,
        route.mode);
      to.segmentIdx++;
    }

    let baseSegmentIdx = segmentIdx; // remember index of base segment. base segment will be modified later

    let newLatLngs = [];

    while (segmentIdx < to.segmentIdx || (pointIdx < to.pointIdx)) {
      newLatLngs.push(route.segments[segmentIdx].coords[pointIdx]);
      pointIdx++;
      if (pointIdx > route.segments[segmentIdx].coordsLastIdx) {
        pointIdx = 1; // we will ignore first (zero) element, its the same as previous

        if (segmentIdx > baseSegmentIdx) { // remove parsed segment if its not base segment
          this.registry.removePolyline(route.segments[segmentIdx].polyline);
          route.remove(segmentIdx);
          to.segmentIdx--;
        } else {
          segmentIdx++;
        }
      }
    }

    if (pointIdx == to.pointIdx) { // end point was not zero point of some segment
      newLatLngs.push(route.segments[segmentIdx].coords[pointIdx]);

      if (pointIdx < route.segments[segmentIdx].coordsLastIdx) { // we have to create last portion of segment

        let postLatLngs = route.segments[segmentIdx].coords.slice(pointIdx);

        if (segmentIdx == baseSegmentIdx) {
          // we still on base segment and have to create NEW segment for last portion
          this.polyline(
            postLatLngs,
            route.segments[segmentIdx].accessibility,
            route,
            route.mapType,
            segmentIdx + 1, null,
            true, '',
            route.created,
            route.mode);
        } else {
          // we are on one of the next segments, so we can just modify current for last portion
          this.changeSegment(route.segments[segmentIdx], postLatLngs, route.segments[segmentIdx].accessibility, route.mapType);
        }
      } else if (segmentIdx > baseSegmentIdx) {
        // we have to remove last segment if its not base
        this.registry.removePolyline(route.segments[segmentIdx].polyline);
        route.remove(segmentIdx);
      }
    }

    // now we modify base segment for new color and save it

    this.changeSegment(route.segments[baseSegmentIdx], newLatLngs, accessibility, route.mapType);
    this.registry.removePolyline(route.segments[baseSegmentIdx].polyline);
    route.remove(baseSegmentIdx);
    // this.optimizeRoute(route);
    this.routeSaver.next(route);
  }

  changeSegment(segment: Segment, newLatlngs: L.LatLng[], accessibility: Accessibility, mapType: MapType) {

    let pl = segment.polyline as L.Polyline;

    let regItem = this.registry.getByPolyline(pl);

    regItem['map'].removeLayer(pl);
    this.layerGroups[mapType][accessibility].addLayer(pl);

    segment.accessibility = accessibility;
    pl.setLatLngs(newLatlngs);
    pl.setStyle({ color: this.colors[accessibility] });

    regItem['map'] = this.layerGroups[mapType][accessibility];
    regItem['accessibility'] = accessibility;
    regItem['mapType'] = mapType;

    return segment
  }

  editMode() {
    if (this.mode == 'edit') {
      this.mode = null;
      return;
    }
    this.mode = 'edit'
  }

  stopEditMode() {
    this.registry.allPolylines().forEach(pl => pl.disableEdit());
  }

  visibleMode() {
    if (this.mode == 'visible') {
      this.mode = null;
      return;
    }
    this.mode = 'visible';
  }

  extendMode() {
    if (this.mode == 'extend') {
      this.mode = null;
      this.map.off('click', this.handleExtendClick, this);
      return;
    }
    this.mode = 'extend'
    this.map.on('click', this.handleExtendClick, this);
  }

  stopExtendMode() {
    this.map.off('click', this.handleExtendClick, this);
    if (this.changesIsExist()) {
      this.confirmPopup.setLatLng(this.map.getBounds().getCenter()).openOn(this.map);
    }
  }

  setColor(color: Accessibility) {
    if (this.mode === 'edit' || this.mode === 'extend') {
      this.currentLatlngs.forEach(e => {
        e.marker.setIcon(this.markerIcons[color]);
      })
      if (this.clickedRoute.polyline) {
        this.clickedRoute.polyline.setStyle({ color: this.colors[color] });
        this.clickedRoute.route.segments[this.clickedRoute.segmentId].accessibility = color;

        let ind = this.changes.findIndex(e => e.polyline == this.clickedRoute.polyline);
        if (ind !== -1) {
          this.changes[ind].chosenColor = color;
        }
        else {
          this.clickedRoute.chosenColor = color;
          this.changes.push(this.clickedRoute);
        }
      }
    }
    else {
      this.mode = 'color';
    }
    this.color = color;
  }

  optimizeRoute(route: Route) {
    let idx = 0;
    while (idx < route.segments.length - 1) {
      let segment = route.segments[idx];
      let nextSegment = route.segments[idx + 1];

      if (segment.accessibility == nextSegment.accessibility) {
        let newLatlngs = segment.coords.concat(nextSegment.coords.slice(1));

        this.registry.removePolyline(nextSegment.polyline);

        nextSegment.polyline.remove();
        route.remove(idx + 1);
        segment.polyline.setLatLngs(newLatlngs);
        idx--;
      }
      idx++;
    }
  }

  getLegend() {

    this.mapLoading = this.dataService.getProjectChecksum(this.projectId).pipe(
      switchMap(result => {
        return combineLatest([
          this.dataService.getPubDictionary('ENG', result.text, this.projectId),
          this.dataService.getLayerSets(this.projectId),
          this.dataService.getLayers(this.projectId),
          this.dataService.genRouteInProject(this.projectId)
        ])
      }),
      switchMap(([dict, layerSets, layers, genRoutes]) => {
        this.markerCluster.clearLayers();

        this.dict = dict;

        this.legend = [];

        let entities$ = [];

        layerSets.forEach(s => {
          this.legend.push({
            value: true,
            key: s.name.toLowerCase(),
            name: `set_${s.layerSetID.id2}`,
            setId: s.layerSetID.id2,
            label: dict.map[s.name.toLowerCase()],
            icon: s.icon.id,
            children: [],
            no_icon: ['LS_TICKETS', 'LS_ROUTES'].includes(s.name)
          });
        });

        layers.forEach(l => {
          let setId = null;
          let legend = null;

          if (l.layer_set_id) {
            setId = l.layer_set_id.id2;
            legend = this.legend.find(s => s.setId == l.layer_set_id.id2).children;
          } else {
            legend = this.legend;
          }

          let colorMap = null;
          let iconMap = null;

          if (l.style_descriptor.dynamic_icon && setId) {

            let tickets = {};
            iconMap = l.style_descriptor.dynamic_icon.map;
            Object.keys(iconMap).forEach(k => {

              tickets[k] = [];

              let item = {
                value: l.default_visible,
                name: `layer_${l.default_entity_type}_${l.layerID.id2}_${k}`,
                key: k.toLowerCase(),
                setId: setId,
                label: dict.map[k.toLowerCase()],
                geomType: l.default_geom_type.toLowerCase(),
                layerId: l.layerID.id2,
                projectId: l.layerID.id1.id,
                publicLayer: l.public_layer,
                defaultVisible: l.default_visible,
                visibleinSubProjects: l.visible_in_sub_projects,
                icon: `assets/img/${iconMap[k]}`,
                show: (key) => {
                  tickets[k].forEach(t => t.addTo(this.markerCluster));
                },
                hide: (key) => {
                  tickets[k].forEach(t => t.removeFrom(this.markerCluster));
                },
              };
              legend.push(item);
              this.flattenLegend.push(item);
            });

            entities$.push(this.dataService.getEntities(this.projectId, l.layerID.id2, l.layerID.id1.id, false).pipe(
              catchError(() => of('err')),
              tap((result: any[] | string) => {
                if (!Array.isArray(result)) {
                  if (result === 'err') {
                    this.fetchingLayerFailed = true;
                  }
                } else {
                  result.forEach(e => {
                    let attrs = Object.assign({ entityID: e.entityID }, { projectID: e.projectID }, e.genericAttributes.attributes);
                    let key = attrs.status[0];
                    let marker = this.marker(attrs, iconMap[key], e.timeStamp);
                    marker.bindTooltip(e.entityID.id2.toString());
                    tickets[key].push(marker);
                  });
                }
              })
            ));


          } else if (l.style_descriptor.dynamic_color && setId) {
            colorMap = l.style_descriptor.dynamic_color.map;

            Object.keys(colorMap).forEach((k: Accessibility) => {
              let item = {
                value: l.default_visible,
                name: `layer_${l.default_entity_type}_${l.layerID.id2}_${k}`,
                setId: setId,
                label: dict.map[k.toLowerCase()],
                geomType: l.default_geom_type.toLowerCase(),
                layerId: l.layerID.id2,
                projectId: l.layerID.id1.id,
                key: k.toLowerCase(),
                publicLayer: l.public_layer,
                defaultVisible: l.default_visible,
                visibleinSubProjects: l.visible_in_sub_projects,
                line: colorMap[k],
                show: (key) => {
                  if (this.layerGroups[this.screen][k]) this.layerGroups[this.screen][k].addTo(this.map);
                },
                hide: (key) => {
                  if (this.layerGroups[this.screen][k]) this.layerGroups[this.screen][k].removeFrom(this.map);
                }
              };
              this.flattenLegend.push(item);
              legend.push(item)
            });

            // entities$.push(this.dataService.getEntities(this.projectId, l.layerID.id2, l.layerID.id1.id, false).pipe(
            entities$.push(this.dataService.getAllRoutes().pipe(
              catchError(() => of('err')),
              tap((result: any[] | string) => {
                if (!Array.isArray(result)) {
                  if (result === 'err') {
                    this.fetchingLayerFailed = true;
                  }
                } else {
                  result.forEach(e => {
                    const route = new Route();
                    route.id = e.entityID.id2;
                    route.projectId = e.projectID.id;
                    const routeAttr = e.genericAttributes.attributes;
                    const mode = routeAttr.mode && routeAttr.mode.length > 0 ? routeAttr.mode[0] : '';
                    const created = e.timeStamp;

                    e.segments.forEach(s => {
                      const attrs = s.genericAttributes.attributes;
                      const key = attrs.accessibility[0];
                      const coords = attrs.geometry[0].coordinates.map(coords => [coords[1], coords[0]]);

                      const hidden = attrs.invisible_in_project
                        && attrs.invisible_in_project.length > 0
                        && attrs.invisible_in_project.indexOf(this.projectId) >= 0;

                      const description = attrs.accessibility_description && attrs.accessibility_description[0] || '';

                      this.polyline(
                        coords,
                        key,
                        route,
                        'crowd',
                        null,
                        s.entityID.id2,
                        !hidden,
                        description,
                        created,
                        mode);
                    });
                  });
                }
              })
            ));

          } else if (l.name !== 'GenRoutes') {
            let key = l.name.toLowerCase();
            iconMap = l.style_descriptor;
            const tagMap = {};

            let item = {
              value: l.default_visible,
              name: `layer_${l.default_entity_type}_${l.layerID.id2}_${key}`,
              setId: setId,
              key: key,
              geomType: l.default_geom_type.toLowerCase(),
              label: l.name,
              layerId: l.layerID.id2,
              projectId: l.layerID.id1.id,
              publicLayer: l.public_layer,
              defaultVisible: l.default_visible,
              visibleinSubProjects: l.visible_in_sub_projects,
              target: null,
              entities: [],
            };


            let iconUrl = iconMap.style_point ? `assets/marker/${iconMap.style_point.icon}` : '';
            let iconAnchor = L.point(28.5, 67);
            let commonCluster = null;
            let targetCluster = null;

            if (l.default_geom_type === 'PUNTAL') {
              item['icon'] = iconMap.style_point ? `assets/img/${iconMap.style_point.icon}` : iconMap.dynamic_icon ? `assets/img/${iconMap.dynamic_icon.map.icon}` : '';
              if (l.name === 'Scholen') {
                iconUrl = `assets/marker/office.png`;
                item['icon'] = iconUrl;
                targetCluster = this.schoolMarkerCluster;
              } else {
                // Common Cluster
                // @ts-ignore
                commonCluster = L.markerClusterGroup({
                  spiderfyOnMaxZoom: true,
                  showCoverageOnHover: false,
                  iconCreateFunction: this.commonClusterIcon,
                });
                this.map.addLayer(commonCluster);
                targetCluster = commonCluster;
              }
              item['show'] = (k) => {
                tagMap[key].forEach(t => t.addTo(targetCluster));
              };
              item['hide'] = (k) => {
                tagMap[key].forEach(t => t.removeFrom(targetCluster));
              };
            } else if (l.default_geom_type === 'LINEAL') {
              item['line'] = iconMap.style_line ? `${iconMap.style_line.color}` : iconMap.dynamic_color ? iconMap.dynamic_color.map.color : '';
              item['show'] = (k) => {
                tagMap[key].forEach(t => t.addTo(this.editableLayers));
                // if ( this.layerGroups[this.screen][key] ) this.layerGroups[this.screen][key].addTo(this.editableLayers);
              };
              item['hide'] = (k) => {
                tagMap[key].forEach(t => t.removeFrom(this.editableLayers));
                // if ( this.layerGroups[this.screen][key] ) this.layerGroups[this.screen][key].removeFrom(this.editableLayers);
              };
            } else if (l.default_geom_type === 'POLYGONAL') {
              item['line'] = iconMap.style_polygon ? `${iconMap.style_polygon.color}` : iconMap.dynamic_color ? iconMap.dynamic_color.map.color : '';
              item['show'] = (k) => {
                tagMap[key].forEach(t => t.addTo(this.editableLayers));
              };
              item['hide'] = (k) => {
                tagMap[key].forEach(t => t.removeFrom(this.editableLayers));
              };
            }

            legend.push(item);
            tagMap[key] = item.entities;
            this.flattenLegend.push(item);

            if (l.default_geom_type === 'PUNTAL') {
              if (l.default_entity_type === 'COMMON' && l.name !== 'Scholen') {
                iconAnchor = L.point(16, 32);
              }
              entities$.push(this.dataService.getEntities(this.projectId, l.layerID.id2, l.layerID.id1.id, false).pipe(
                catchError(() => of('err')),
                tap((result: any[] | string) => {
                  if (!Array.isArray(result)) {
                    if (result === 'err') {
                      this.fetchingLayerFailed = true;
                    }
                  } else {
                    result.forEach(e => {
                      let attrs = Object.assign({ entityID: e.entityID }, { projectID: e.projectID }, e.genericAttributes.attributes);
                      let marker = L.marker(this.latLng(attrs.geometry[0].coordinates), {
                        icon: L.icon({
                          iconUrl: iconUrl,
                          iconAnchor
                        })
                      });
                      marker['entityID'] = e.entityID ? e.entityID.id2 : null;
                      marker['projectID'] = e.projectID ? e.projectID.id : null;
                      if (key === "scholen") {
                        if (attrs.name) marker.bindTooltip(attrs.name[0]);
                      } else {
                        if (attrs.description && attrs.description[0]) marker.bindTooltip(attrs.description[0], {
                          offset: [0, -67]
                        });
                      }
                      if (item.defaultVisible) {
                        if (key === "scholen") {
                          this.schoolMarkerCluster.addLayer(marker)
                        } else {
                          commonCluster.addLayer(marker)
                        }
                      }
                      tagMap[key].push(marker);
                    });
                  }
                })
              ));
            }
            else if (l.default_geom_type === 'LINEAL') {
              let routes$ = this.dataService.getEntities(this.projectId, l.layerID.id2, l.layerID.id1.id, false);

              entities$.push(routes$.pipe(
                catchError(() => of('err')),
                tap((result: any[] | string) => {
                  if (!Array.isArray(result)) {
                    if (result === 'err') {
                      this.fetchingLayerFailed = true;
                    }
                  } else {
                    result.forEach(e => {

                      let attrs = e.genericAttributes.attributes;
                      let coords = attrs.geometry[0].coordinates.map(coords => [coords[1], coords[0]]);

                      let pl = L.polyline(coords, { color: l.style_descriptor.style_line ? l.style_descriptor.style_line.color : '#000', weight: 5 });
                      pl['entityID'] = e.entityID ? e.entityID.id2 : null;
                      pl['projectID'] = e.projectID ? e.projectID.id : null;
                      if (item.defaultVisible) pl.addTo(this.editableLayers);
                      tagMap[key].push(pl);
                    });
                  }
                })
              ));
            }
            else if (l.default_geom_type === 'POLYGONAL') {

              let routes$ = this.dataService.getEntities(this.projectId, l.layerID.id2, l.layerID.id1.id, false);

              entities$.push(routes$.pipe(
                catchError(() => of('err')),
                tap((result: any[] | string) => {
                  if (!Array.isArray(result)) {
                    if (result === 'err') {
                      this.fetchingLayerFailed = true;
                    }
                  } else {
                    result.forEach(e => {

                      let attrs = e.genericAttributes.attributes;
                      if (attrs.geometry[0].type === "Polygon") {
                        const coords = new Array();
                        attrs.geometry[0].coordinates[0].forEach(e => coords.push(e.reverse()));
                        coords.splice(coords.length - 1, 1);

                        const color = l.style_descriptor.style_polygon ? l.style_descriptor.style_polygon.color : '#bada55';

                        const pl = L.polygon(coords, { color, weight: 2, fillOpacity: 0 });
                        pl['entityID'] = e.entityID ? e.entityID.id2 : null;
                        pl['projectID'] = e.projectID ? e.projectID.id : null;

                        if (item.defaultVisible) pl.addTo(this.editableLayers);
                        tagMap[key].push(pl);
                      }
                    });
                  }
                })
              ));

            }
          }
        });
        this.fetchingLayerFailed = false;
        return combineLatest(entities$);

      })
    ).subscribe(() => { this.updateByLegend(); });
  }

  updateByLegend() {
    this.layerGroups.crowd.OCCASIONALLY_UNSAFE.removeFrom(this.map);
    this.layerGroups.crowd.SAFE.removeFrom(this.map);
    this.layerGroups.crowd.UNSAFE.removeFrom(this.map);
    this.layerGroups.generalized.OCCASIONALLY_UNSAFE.removeFrom(this.map);
    this.layerGroups.generalized.SAFE.removeFrom(this.map);
    this.layerGroups.generalized.UNSAFE.removeFrom(this.map);

    this.flattenLegend.forEach(l => {
      l.hide(l.key);
      if (l.value) l.show(l.key);
    });
  }

  legendChanged(legend) {
    if ('children' in legend && legend.children.length) {
      legend.children.forEach(sl => sl.value = legend.value);
    }
    this.updateByLegend();
  }

  subLegendChanged(parent) {
    parent.value = parent.children.reduce((flag, sl) => flag && sl.value, true);
    this.updateByLegend();
  }

  private marker(attrs: any, icon: string, timestamp) {
    let marker = L.marker(this.latLng(attrs.geometry[0].coordinates), {
      status: attrs.status[0],
      icon: L.icon({
        iconUrl: `assets/img/${icon}`,
        iconAnchor: L.point(23, 57)
      })
    } as L.MarkerOptions);

    marker.on('click', e => {
      this.markerPopup = Object.assign({}, attrs, { timestamp: timestamp });
      this.popupShown = true;

      console.log(attrs);

    });

    return marker;
  }

  closePopup() {
    this.popupShown = false;
  }

  private latLng(ll) {
    return L.latLng(ll[1], ll[0]);
  }

  clusterIcon(cluster) {
    const markers = cluster.getAllChildMarkers();
    let types = [];
    markers.forEach(m => {
      let attr = m.options['status'];
      switch (attr) {
        case 'REPORTED':
          types[0] = 'r';
          break;
        case 'COMPLETED':
          types[1] = 'g';
          break;
        case 'PROCESSING':
          types[2] = 'b';
      }
    });

    let colorClass = types.join('');
    return L.divIcon({ html: markers.length, className: `cluster cluster-${colorClass}`, iconSize: L.point(47, 47) });
  }

  schoolClusterIcon(cluster) {
    const markers: Array<L.Marker> = cluster.getAllChildMarkers();
    return L.divIcon({ html: `<span class='badge badge-office'>${markers.length}</span>`, className: `cluster cluster-office`, iconSize: L.point(57, 67) });
  }

  commonClusterIcon(cluster) {
    const markers: Array<L.Marker> = cluster.getAllChildMarkers();
    let icon: L.Icon<L.IconOptions> | L.DivIcon = null;
    if (markers.length > 0) {
      const marker = markers[0];
      icon = marker.getIcon();
    }
    return L.divIcon({ html: `<img src="${icon && icon.options.iconUrl}"><span class='badge badge-common'>${markers.length}</span>`, className: `cluster cluster-common`, iconSize: L.point(32, 32) });
  }

  editTicket(data) {
    console.log(data);
  }

  get mapIsEditable() {
    return this.editableState == this.screen && !this.creating;
  }

  get selectedRoute(): Route {
    return this._selectedRoute;
  }

  set selectedRoute(value: Route) {

    if (this._selectedRoute != value) {

      // restore default style for previously selected route
      if (this._selectedRoute) {
        this._selectedRoute.segments.forEach(s => {
          let pl = s.polyline as L.Polyline;
          pl.setStyle({
            weight: 5,
            lineCap: 'round',
            dashArray: null
          });
        });
      }

      // set 'selected' style to a newly selected route
      if (value) {
        value.segments.forEach(s => {
          let pl = s.polyline as L.Polyline;
          pl.setStyle({
            weight: 7,
            lineCap: 'butt',
            dashArray: '3, 1'
          });
        });
      }

    }

    this._selectedRoute = value;
  }

  segmentOver(segment: Segment) {
    const pl = segment.polyline as L.Polyline;
    pl.setStyle({
      lineCap: 'round',
      dashArray: null
    });
  }

  segmentOut(segment: Segment) {
    const pl = segment.polyline as L.Polyline;
    pl.setStyle({
      lineCap: 'butt',
      dashArray: '3, 1'
    });
  }

  routeOver(route: Route) {
    for (const segment of route.segments) {
      const pl = segment.polyline as L.Polyline;
      pl.setStyle({
        opacity: 1,
        lineCap: 'butt',
        dashArray: '3, 1'
      });
    }
  }

  routeOut(route: Route) {
    for (const segment of route.segments) {
      const pl = segment.polyline as L.Polyline;
      pl.setStyle({
        opacity: 0,
        lineCap: 'round',
        dashArray: null
      });
    }
  }

  routeClickHandler(route: Route) {
    this.selectedRoute = route;
    this.restoreVisibilityRoutes();
    this.chosenRoutes = [];
  }

  cancelRouteEdit() {
    this.selectedRoute = null;
    this.restoreVisibilityRoutes();
    this.chosenRoutes = [];
  }

  visibleHiddenSegments() {
    this.hiddenSegments.forEach(e => {
      let pl = <L.Polyline>e.polyline;
      pl.setStyle({ opacity: e.visible ? 1.0 : this.hiddenSwitch ? 0.3 : 0 });
    })
  }

  saveSegmentVisibility(selectedRoute: Route, segment: Segment, visible: boolean) {
    segment.saving = this.dataService.updateSegmentVisibility(
      this.screen,
      selectedRoute.projectId,
      selectedRoute.id,
      segment.id,
      visible).pipe(

    ).subscribe(() => {
      segment.visible = visible;
      let pl = <L.Polyline>segment.polyline;
      pl.setStyle({ opacity: visible ? 1.0 : this.hiddenSwitch ? 0.3 : 0 });
      this.hiddenSegments.push(segment);
    });
  }

  saveSegment(route: Route, segment: Segment) {
    segment.saving = this.dataService.updateSegmentAccessibility(route.projectId, route.id, segment.id, segment.accessibility).pipe(
      mergeMap(() => this.dataService.updateSegmentDescription(route.projectId, route.id, segment.id, segment.description || "")),
      mergeMap(() => this.dataService.getRouteById(route.mapType, route.projectId, route.id)),
      tap(r => {
        r.segments.forEach((s, i) => {
          let attr = r.segments[i].genericAttributes.attributes;

          let newAccessibility = attr.accessibility[0];
          let newDescription = (attr.accessibility_description && attr.accessibility_description[0]) || "";
          route.segments[i].accessibility = newAccessibility;
          route.segments[i].description = newDescription;
          route.segments[i].polyline.setStyle({ color: this.colors[newAccessibility] });
        });
      })
    ).subscribe();
  }

  locateRoute(route: Route) {
    let coords: L.LatLng[] = [];
    route.segments.forEach(s => coords = coords.concat(s.polyline.getLatLngs()));
    this.map.fitBounds(L.latLngBounds(coords), { paddingBottomRight: [420, 0] });
  }

  openAttachModal(id) {
    const options: NgbModalOptions = {
      backdrop: true,
      keyboard: false,
      centered: true,
      windowClass: 'attachImageModal'
    };

    const dlg = this.modalService.open(TicketImagesModalComponent, options);
    dlg.componentInstance.images = this.markerPopup.image;
    dlg.componentInstance.selectedID = id;
  }

  openNewLayerModal(layer = null) {
    const options: NgbModalOptions = {
      backdrop: true,
      keyboard: false,
      centered: true,
      windowClass: 'newLayerModal'
    };

    const dlg = this.modalService.open(NewLayerComponent, options);
    dlg.componentInstance.layer = layer;
    dlg.result.then(ok => {
      this.dataService.getLayers(this.projectId).subscribe(layers => {
        layers.forEach(l => {
          if (l.name !== 'GenRoutes' && l.name !== 'Routes' && l.name !== 'Reports') {
            const filterLegends = this.legend.filter(e => e.label === l.name && e.geomType === l.default_geom_type.toLowerCase());
            if (!filterLegends.length) {
              let setId = null;
              let legend = null;

              if (l.layer_set_id) {
                setId = l.layer_set_id.id2;
                legend = this.legend.find(s => s.setId == l.layer_set_id.id2).children;
              } else {
                legend = this.legend;
              }

              let colorMap = null;
              let iconMap = null;

              let key = l.name.toLowerCase();
              iconMap = l.style_descriptor;
              const tagMap = {};

              let item = {
                value: true,
                name: `layer_${l.default_entity_type}_${l.layerID.id2}_${key}`,
                setId: setId,
                key: key,
                geomType: l.default_geom_type.toLowerCase(),
                label: l.name,
                layerId: l.layerID.id2,
                projectId: l.layerID.id1.id,
                publicLayer: l.public_layer,
                defaultVisible: l.default_visible,
                visibleinSubProjects: l.visible_in_sub_projects,
                target: null,
                entities: [],
              };
              if (l.default_geom_type === 'PUNTAL') {
                item['icon'] = iconMap.style_point ? `assets/img/${iconMap.style_point.icon}` : iconMap.dynamic_icon ? `assets/img/${iconMap.dynamic_icon.map.icon}` : '';
                item['show'] = (key) => {
                  const legend = this.flattenLegend.find(e => e.key === key);
                  if (legend && legend.entities) {
                    legend.entities.forEach(t => t.addTo(this.editableLayers));
                  }
                };
                item['hide'] = (key) => {
                  const legend = this.flattenLegend.find(e => e.key === key);
                  if (legend && legend.entities) {
                    legend.entities.forEach(t => t.removeFrom(this.editableLayers));
                  }
                };
              } else if (l.default_geom_type === 'LINEAL') {
                item['line'] = iconMap.style_line ? `${iconMap.style_line.color}` : iconMap.dynamic_color ? iconMap.dynamic_color.map.color : '';
                item['show'] = (key) => {
                  const legend = this.flattenLegend.find(e => e.key === key);
                  if (legend && legend.entities) {
                    legend.entities.forEach(t => t.addTo(this.editableLayers));
                  }
                };
                item['hide'] = (key) => {
                  const legend = this.flattenLegend.find(e => e.key === key);
                  if (legend && legend.entities) {
                    legend.entities.forEach(t => t.removeFrom(this.editableLayers));
                  }
                };
              } else if (l.default_geom_type === 'POLYGONAL') {
                item['line'] = iconMap.style_polygon ? `${iconMap.style_polygon.color}` : iconMap.dynamic_color ? iconMap.dynamic_color.map.color : '';
                item['show'] = (key) => {
                  const legend = this.flattenLegend.find(e => e.key === key);
                  if (legend && legend.entities) {
                    legend.entities.forEach(t => t.addTo(this.editableLayers));
                  }
                };
                item['hide'] = (key) => {
                  const legend = this.flattenLegend.find(e => e.key === key);
                  if (legend && legend.entities) {
                    legend.entities.forEach(t => t.removeFrom(this.editableLayers));
                  }
                };
              }

              let iconUrl = iconMap.style_point ? `assets/marker/${iconMap.style_point.icon}` : '';
              if (l.name === 'Scholen') {
                iconUrl = `assets/marker/office.png`;
              }

              legend.push(item);
              tagMap[key] = item.entities;
              this.flattenLegend.push(item);
            }
            else {
              let iconMap = null;

              let key = l.name.toLowerCase();
              iconMap = l.style_descriptor;

              filterLegends.forEach(fl => {
                fl.key = key;
                fl.label = l.name;
                fl.name = `layer_${l.default_entity_type}_${l.layerID.id2}_${key}`;

                if (l.default_geom_type === 'PUNTAL') {
                  fl['icon'] = iconMap.style_point ? `assets/img/${iconMap.style_point.icon}` : iconMap.dynamic_icon ? `assets/img/${iconMap.dynamic_icon.map.icon}` : '';
                } else if (l.default_geom_type === 'LINEAL') {
                  fl['line'] = iconMap.style_line ? `${iconMap.style_line.color}` : iconMap.dynamic_color ? iconMap.dynamic_color.map.color : '';
                } else if (l.default_geom_type === 'POLYGONAL') {
                  fl['line'] = iconMap.style_polygon ? `${iconMap.style_polygon.color}` : iconMap.dynamic_color ? iconMap.dynamic_color.map.color : '';
                }
              });
              // this.flattenLegend.push(item);
            }
          }
        });
      });
    });
  }

  removeLayer(layer) {
    this.dropdown.close();
    const confirm = this.modalService.open(ConfirmSentComponent);
    confirm.componentInstance.data = {
      text: 'Are you sure you want to remove the selected layer',
      header: 'Remove Layer'
    };
    confirm.result.then(ok => {
      this.isProceed = true;
      this.isLoadingText = 'Layer removing';
      this.dataService.removeLayer(layer.projectId, layer.layerId).subscribe(response => {

        this.isProceed = false;
        this.removeLayerEntities(layer.key);
        const infoDlg = this.modalService.open(InfoModalComponent);
        infoDlg.componentInstance.data = {
          text: 'The layer has been deleted',
          header: 'Info'
        };
        infoDlg.result.then(ok => {
          const index = this.legend.indexOf(layer, 0);
          if (index > -1) {
            this.legend.splice(index, 1);
          }
          const flattenIndex = this.flattenLegend.indexOf(layer, 0);
          if (flattenIndex > -1) {
            this.flattenLegend.splice(flattenIndex, 1);
          }
        });
      }, error => {
      });
    }).catch(reason => {
    });
  }

  getImgAbsoluteUrl(imgId) {
    if (imgId.indexOf('assets') != -1) return imgId;
    else return `${this.config.getHost()}/api2/public/image?image_id=${imgId}`;
  }

  addHomeMarker() {
    let userLocation = this.userService.user.attributes.location[0].coordinates;
    var homeMarker = L.marker(new L.LatLng(userLocation[1], userLocation[0]), {
      icon: L.icon({ iconUrl: 'assets/marker/home.png', iconSize: [57, 67], iconAnchor: [27, 66] }),
      draggable: true
    });

    homeMarker.bindTooltip(`${this.userService.user.attributes.address[0].street} ${this.userService.user.attributes.address[0].houseNumber}`);

    this.map.addLayer(homeMarker);
  }

  filterLegendItems() {
    return this.legend.filter(x => !x.children);
  }

  isEmpty(obj) {
    return Object.keys(obj).length === 0;
  }

  layerListClick(e, item) {
    this.selectedLayer = item;

    this.hideLayerEntities();
    this.showLayerEntities(item.key);

    if (this.selectedLayer.geomType == 'puntal') {

      const selectedLayerIcon = L.Icon.extend({
        options: {
          shadowUrl: null,
          iconAnchor: new L.Point(16, 16),
          iconSize: new L.Point(32, 32),
          iconUrl: this.selectedLayer.icon
        }
      });

      this.drawControl.setDrawingOptions({
        polyline: false,
        polygon: false,
        marker: {
          icon: new selectedLayerIcon()
        }
      });
    }

    if (this.selectedLayer.geomType == 'lineal') {
      this.drawControl.setDrawingOptions({
        polyline: {
          shapeOptions: {
            color: this.selectedLayer.line,
          }
        },
        polygon: false,
        marker: false
      });
    }

    if (this.selectedLayer.geomType == 'polygonal') {
      this.drawControl.setDrawingOptions({
        polyline: false,
        polygon: {
          allowIntersection: false, // Restricts shapes to simple polygons
          drawError: {
            color: '#e1e100', // Color the shape will turn when intersects
            message: '<strong>Oh snap!<strong> you can\'t draw that!' // Message that will show when intersect
          },
          shapeOptions: {
            color: this.selectedLayer.line
          }
        },
        marker: false
      });
    }

    if (!this.isToolbarInserted) {
      this.isToolbarInserted = true;
      this.map.addControl(this.drawControl);
    }
    else {
      this.map.removeControl(this.drawControl);
      this.map.addControl(this.drawControl);
    }
  }

  hideLayerEntities() {
    this.layerGroups.crowd.OCCASIONALLY_UNSAFE.removeFrom(this.map);
    this.layerGroups.crowd.SAFE.removeFrom(this.map);
    this.layerGroups.crowd.UNSAFE.removeFrom(this.map);
    this.layerGroups.generalized.OCCASIONALLY_UNSAFE.removeFrom(this.map);
    this.layerGroups.generalized.SAFE.removeFrom(this.map);
    this.layerGroups.generalized.UNSAFE.removeFrom(this.map);

    this.flattenLegend.forEach(l => {
      l.hide();
    });
  }

  removeLayerEntities(key) {
    this.flattenLegend.forEach(l => {
      if (l.key == key) {
        l.hide(key);
      }
    });
  }

  showLayerEntities(key) {
    this.flattenLegend.forEach(l => {
      if (l.key == key) l.show(key);
    });
  }

  mapClickHandler() {
    return (e) => {
      if (this.optShown) {
        this.optShown = false;
        console.log('map click', e);
      }
    }
  }

  mapDrawCreatedHandler() {
    return (e: L.LeafletEvent) => {
      console.log('L.Draw.Event.CREATED', e);

      if (!_.isEmpty(this.selectedLayer)) {
        var type = e.type,
          layer = e.layer;
        // Do whatever else you need to. (save to db, add to map etc)
        this.editableLayers.addLayer(layer);

        this.isProceed = true;
        this.isLoadingText = 'Entity Adding';

        this.dataService.createEntity(this.selectedLayer, e, this.projectId).subscribe(res => {

          layer.entityID = res['id2'];
          layer.projectID = res['id1']['id'];

          this.selectedLayer.entities.push(layer);
          this.isProceed = false;
        });
      }
      else {
        let route = new Route();
        route.projectId = this.projectId;
        this.polyline(e.layer._latlngs, this.color, route, this.screen);
        this.routeSaver.next(route);
        this.mode = null;
        timer(300).subscribe(() => { this.startDraw(); });
      }
    }
  }

  mapDrawEditedHandler() {
    return (e: L.LeafletEvent) => {
      console.log('L.Draw.Event.EDITED', e);
      if (e['layers']) {
        let layerCount = new Array(e['layers']._layers.length).fill(0);
        let layers = e['layers']._layers;

        if (Object.keys(e['layers']._layers).length > 0) {
          this.isProceed = true;
          this.isLoadingText = 'Entity Updating';
          Object.keys(e['layers']._layers).forEach(key => {
            this.dataService.removeEntity(this.selectedLayer.projectId,
              this.selectedLayer.layerId,
              layers[key].projectID,
              layers[key].entityID
            ).pipe(
              mergeMap(result => this.dataService.createEntity(this.selectedLayer, {
                layer: layers[key],
                layerType: this.selectedLayer.geomType == 'puntal' ? 'marker' : this.selectedLayer.geomType == 'lineal' ? 'polyline' : 'polygon'
              }, this.projectId)),
              map(res => {
                const index = this.selectedLayer.entities.indexOf(layers[key], 0);
                this.selectedLayer.entities[index].entityID = res['id2'];
                this.selectedLayer.entities[index].projectID = res['id1']['id'];
                layerCount.pop();
                if (layerCount.length == 0) this.isProceed = false;
              })
            )
              .subscribe((res) => {
                console.log(res);
              });
          });
        }
      }
    }
  }

  mapDrawDeletedHandler() {
    return (e: L.LeafletEvent) => {
      console.log('L.Draw.Event.DELETED', e);
      if (e['layers']) {
        let layerCount = new Array(e['layers']._layers.length).fill(0);
        let layers = e['layers']._layers;

        if (Object.keys(e['layers']._layers).length > 0) {
          this.isProceed = true;
          this.isLoadingText = 'Entity Removing';
          Object.keys(e['layers']._layers).forEach(e => {
            this.dataService.removeEntity(this.selectedLayer.projectId,
              this.selectedLayer.layerId,
              layers[e].projectID,
              layers[e].entityID
            )
              .subscribe(() => {
                const index = this.selectedLayer.entities.indexOf(layers[e], 0);
                if (index > -1) {
                  this.selectedLayer.entities.splice(index, 1);
                }
                layerCount.pop();
                if (layerCount.length == 0) this.isProceed = false;
              });
          });
        }
      }
    }
  }

  uploadShapeFile(item) {
    this.selectedLayer = item;
    this.fileInput.nativeElement.click();
  }

  onFileChange(event) {

    if (event.target.files.length > 0) {
      this.shapeFile = event.target.files[0];
    }
    else {
      this.shapeFile = null;
    }

    if (Object.keys(this.selectedLayer).length > 0 && this.shapeFile) {
      this.isProceed = true;
      this.isLoadingText = 'Uploading Shapefile';
      this.dataService.uploadShapeFile(this.shapeFile, this.selectedLayer, this.projectId).subscribe(
        res => {
          console.log(res);
          this.isProceed = false;
          this.removeLayerEntities(this.selectedLayer.key);
          this.reloadLayer();
          this.fileInput.nativeElement.value = '';
        },
        err => {
          this.isProceed = false;
          this.fileInput.nativeElement.value = '';
          console.log(err);
        }
      );
    }
    else {
      alert("Please select layer or choose file");
    }
  }

  reloadLayer() {

    let key = this.selectedLayer.name.toLowerCase();
    this.selectedLayer.entities = [];

    let iconUrl = this.selectedLayer.icon ? this.selectedLayer.icon : '';
    if (this.selectedLayer.name === 'Scholen') {
      iconUrl = `assets/marker/office.png`;
    }

    this.mapLoading = this.dataService.getEntities(this.projectId, this.selectedLayer.layerId, this.selectedLayer.projectId, false).pipe(
      switchMap((entities) => {
        if (this.selectedLayer.geomType === 'puntal') {
          entities.forEach(e => {
            let attrs = Object.assign({ entityID: e.entityID }, { projectID: e.projectID }, e.genericAttributes.attributes);
            let marker = L.marker(this.latLng(attrs.geometry[0].coordinates), {
              icon: L.icon({
                iconUrl: iconUrl,
                iconAnchor: L.point(29, 67)
              })
            });
            marker['entityID'] = e.entityID ? e.entityID.id2 : null;
            marker['projectID'] = e.projectID ? e.projectID.id : null;
            if (key === "scholen") {
              if (attrs.name) marker.bindTooltip(attrs.name[0]);
            } else {
              if (attrs.description && attrs.description[0]) marker.bindTooltip(attrs.description[0], {
                offset: [0, 67]
              });
            }
            this.editableLayers.addLayer(marker);

            this.selectedLayer.entities.push(marker);
          });
        }
        else if (this.selectedLayer.geomType === 'lineal') {
          entities.forEach(e => {

            let attrs = e.genericAttributes.attributes;
            let coords = attrs.geometry[0].coordinates.map(coords => [coords[1], coords[0]]);

            let pl = L.polyline(coords, { color: this.selectedLayer.line, weight: 5 });
            pl['entityID'] = e.entityID ? e.entityID.id2 : null;
            pl['projectID'] = e.projectID ? e.projectID.id : null;
            pl.addTo(this.editableLayers);
            this.selectedLayer.entities.push(pl);
          });
        }
        else if (this.selectedLayer.geomType === 'polygonal') {

          entities.forEach(e => {

            let attrs = e.genericAttributes.attributes;
            if (attrs.geometry[0].type === "Polygon") {
              let coords = new Array();
              attrs.geometry[0].coordinates[0].forEach(e => coords.push(e.reverse()));
              coords.splice(coords.length - 1, 1);

              const color = this.selectedLayer.style_descriptor.style_polygon ? this.selectedLayer.line : '#bada55';
              const fillColor = this.selectedLayer.style_descriptor.style_polygon ? this.selectedLayer.style_descriptor.style_polygon.fillColor : '#bada55';
              const fillOpacity = this.selectedLayer.style_descriptor.style_polygon ? this.selectedLayer.style_descriptor.style_polygon.fillOpacity : 0.5;

              const pl = L.polygon(coords, { color, fillColor, weight: 5, fillOpacity });
              pl['entityID'] = e.entityID ? e.entityID.id2 : null;
              pl['projectID'] = e.projectID ? e.projectID.id : null;
              pl.addTo(this.editableLayers);
              this.selectedLayer.entities.push(pl);
            }
          });
        }
        return of(entities);

      })
    ).subscribe((e) => {
      this.showLayerEntities(this.selectedLayer.key);
    });
  }

  clickedLine(polyline: L.Polyline, latlng: L.LatLng) {
    let points = polyline.getLatLngs() as L.LatLng[];

    let prevDelta: number = null;
    let idx: number = null;

    for (let i = 0; i < points.length - 1; i++) {
      let latLngA = points[i];
      let latLngB = points[i + 1];

      let hypotenuse = latLngA.distanceTo(latLngB);
      let delta = latLngA.distanceTo(latlng) + latlng.distanceTo(latLngB) - hypotenuse;

      if (prevDelta === null || prevDelta > delta) {
        prevDelta = delta;
        idx = i;
      }
    }

    return idx;
  }

  getMapHeight() {
    return this.fetchingLayerFailed && this.isProjectMnger() ? 'calc(82vh - 44px)' : '82vh';
  }
}
